import { Button } from "@/components/ui/button";
import { formatPrice } from "@/utils/currency";
import { Check } from "lucide-react";

export function OrderSuccessScreen({ orderCreated, customerName, total, paymentType, cardBrand, changeAmount, onNewOrder }) {
  const payLabel = paymentType === "card"
    ? (cardBrand || "").replace(/_/g, " ") || "Presencial"
    : paymentType || "-";
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-testid="order-success">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
        <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
          <Check className="w-8 h-8 text-emerald-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Pedido Criado!</h1>
        <p className="text-gray-500 mb-4">O pedido foi registado e enviado para a cozinha.</p>
        <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Pedido</span>
            <span className="font-mono font-bold">#{(orderCreated?.id || "").slice(-6).toUpperCase()}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Cliente</span>
            <span>{customerName || "-"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Total</span>
            <span className="font-bold text-emerald-700">{formatPrice(total)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Pagamento</span>
            <span className="capitalize">{payLabel}</span>
          </div>
          {changeAmount > 0 && (
            <div className="flex justify-between text-sm font-bold text-amber-700 border-t pt-2">
              <span>Troco a devolver</span>
              <span>{formatPrice(changeAmount)}</span>
            </div>
          )}
        </div>
        <div className="flex gap-3">
          <Button variant="outline" className="flex-1" onClick={onNewOrder} data-testid="new-order-again-btn">
            Nuevo Pedido
          </Button>
          <Button className="flex-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => { window.location.href = "/orders"; }} data-testid="close-tab-btn">
            Cerrar
          </Button>
        </div>
      </div>
    </div>
  );
}
